/**
 * 车身类型弹窗
 */
import React, { useEffect, useState } from 'react';
import {
  getCarTypeRequest,
  setCarTypeRequest
} from '@/service/parameterConfiguration';
import {
  queryCanDbc,
  setJtKlsCanDbcRequest,
} from '@/service/jtKlsParameterConfiguration';
import { Form, message, Modal, Select } from 'antd';

interface CarTypeModalProps {
  data: any; // 数据
  closeModal: () => void; // 关闭弹窗的方法
}
const DBCDownLineModal = (props: CarTypeModalProps) => {
  const {
    data: { sn },
    closeModal
  } = props;

	// const sn = '1325120005'

  const [DBCList, setDBCList] = useState([])

  const [DBCForm] = Form.useForm()

  useEffect(() => {
    queryCanDbc(sn).then((res) => {
        const data = res?.data?.data || []
        data.forEach((item: any) => {
            item.label = item.fileName
            item.value = item.id
        })
        setDBCList(res?.data?.data || [])
    })
  }, [sn])

  const submit = (values: any) => {
		const params = {...values}
		params.vehicleType = 1000
		setJtKlsCanDbcRequest({sn: sn, reuqestParams: params}).then(() => {
			message.success('下发成功')
			closeModal()
		}).catch((e) => {
			message.error('下发失败')
		})
  }

  return (
    <Modal title="下发DBC文件" onCancel={closeModal} onOk={DBCForm.submit} open>
        <Form form={DBCForm} onFinish={submit}>
            <Form.Item label="DBC文件" rules={[{ required: true, message: '请选择DBC文件' }]} name={'dbcId'}>
                <Select options={DBCList} placeholder="请选择DBC文件"  />
            </Form.Item>
        </Form>
    </Modal>
  );
};

export default DBCDownLineModal;
